import { getCompanyLookupCopy } from './companyLookupCopy'
import './DecisionMakerFields.css'

const labels = {
  fr: ['Vos coordonnées', 'Prénom et nom du décisionnaire', 'Titre du poste', 'Ex. : Gérant, Directrice, Responsable des achats', 'Téléphone professionnel'],
  de: ['Ihre Kontaktdaten', 'Vor- und Nachname des Entscheidungsträgers', 'Berufsbezeichnung', 'Z. B. Geschäftsführer, Direktorin, Einkaufsleiter', 'Geschäftliche Telefonnummer'],
  it: ['I vostri recapiti', 'Nome e cognome del responsabile decisionale', 'Titolo del ruolo', 'Es.: Gerente, Direttrice, Responsabile acquisti', 'Telefono professionale'],
  en: ['Your contact details', 'Decision-maker’s full name', 'Job title', 'E.g. Owner, Director, Head of Procurement', 'Business phone number'],
}

export default function DecisionMakerFields({ value, onChange, lang = 'fr', disabled = false }) {
  const [legend, name, title, example, phone] = labels[lang] || labels.fr
  return <fieldset className="hb-decision-maker" disabled={disabled}>
    <legend>{legend}</legend>
    <p>{getCompanyLookupCopy(lang).decisionMaker}</p>
    <label>{name} *<input required autoComplete="name" value={value.contactName}
      onChange={e => onChange({ ...value, contactName: e.target.value })} /></label>
    <label>{title} *<input required autoComplete="organization-title" placeholder={example} value={value.contactTitle}
      onChange={e => onChange({ ...value, contactTitle: e.target.value })} /></label>
    <label>{phone} *<input required type="tel" inputMode="tel" autoComplete="tel" value={value.contactPhone}
      onChange={e => onChange({ ...value, contactPhone: e.target.value })} /></label>
  </fieldset>
}
